import dotenv from "dotenv";
dotenv.config();

export default class ConfigProvider {
  public static get CONFIG(): any {
    return {
      apiUri: "$VUE_APP_API_URI",
      clientId: "$VUE_APP_CLIENT_ID",
      idDomain: "$VUE_APP_ID_DOMAIN",
      scope: "$VUE_APP_SCOPE",
    };
  }

  public static value(name: string): string {
    if (!(name in this.CONFIG)) {
      return "";
    }

    const value = this.CONFIG[name];

    if (!value) {
      return "";
    }

    if (value.startsWith("$VUE_APP_")) {
      const envName = value.substr(1);
      const envValue = process.env[envName];
      if (envValue) {
        return envValue;
      } else {
        return "";
      }
    } else {
      return value;
    }
  }
}
